import React, {useEffect, useRef, useState} from 'react'
import {useParams} from 'react-router-dom'
import {default as Select} from "react-select"
import useStateRef from "react-usestateref"
import 'react-datepicker/dist/react-datepicker.css'
import * as dayjs from 'dayjs'
import * as utc from 'dayjs/plugin/utc'
import * as timezone from 'dayjs/plugin/timezone'
import * as relativeTime from 'dayjs/plugin/relativeTime'
import {useSolv} from "./components/SolvProvider"
import {useIntlEx} from "./components/IntlUtils.js"
import {
  clearAllErrors,
  clearError,
  InfoBlock,
  InfoText,
  validateEmailAddress,
  validateField,
  validateUrl
} from './components/ValidationUtils.js';
import {closeDialog, ModalDialog} from "./components/DialogUtils";
import {ActionButton, FormGroup, FormGroups, Icon, NumericInput, useAlert} from "./components/FormComps";
import {ImageDropBox, processImageFile, uploadImage} from "./components/ImageUtils";
import ImageDialog from "./components/ImageDialog";
import {rangeMap} from "./components/CommonUtils";
import {AsyncPaginate, reduceGroupedOptions} from "react-select-async-paginate";
import {mkHref, useResellerType, useTaxType, useTenantPlan} from "./components/AccountUtils";
import {numberIsNotBlank} from "./components/Utils";
import getLogger from "./components/Logging.js"
import './App.css'

const log = getLogger("ResellerInviteDialog")

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

export default function ResellerInviteDialog(props)  {

  const {env, api, session:{user}, setBusy, setFatal} = useSolv()

  const {intl} = useIntlEx()

  const {taxTypeOpts, findTaxTypeOpt} = useTaxType()
  const {tenantPlanOpts, findTenantPlanOpt} = useTenantPlan("RESELLER", ["COMMISSION", "DEMO", "HOUSE"])
  const {getInvitableResellerTypeOpts} = useResellerType()

  const [tenant, setTenant] = useState(null)

  const [region, setRegion] = useState(null)
  const [tenantId, setTenantId] = useState(null)
  const [fullName, setFullName] = useState(null)
  const [emailAddress, setEmailAddress] = useState(null)
  // const [industry, setIndustry] = useState(findIndustryOpt("PUBLIC_SAFETY"))
  const [tenantName, setTenantName] = useState(null)
  const [contactName, setContactName] = useState(null)
  const [tenantPlan, setTenantPlan] = useState(findTenantPlanOpt("COMMISSION"))
  const [resellerType, setResellerType] = useState(null)
  const [resellerTypeOpts, setResellerTypeOpts] = useState(null)
  const [maxLevels, setMaxLevels, maxLevelsRef] = useStateRef(2)
  const [commissionRates, setCommissionRates, commissionRatesRef] = useStateRef([5.0])
  const [affiliateCommissionRate, setAffiliateCommissionRate] = useState(0.0)
  const [affiliateAdjustmentRate, setAffiliateAdjustmentRate] = useState(0.0)
  const [cpm, setCpm] = useState(5.0)
  const [broadcastTemplates, setBroadcastTemplates] = useState(null)
  const [broadcastTemplateOpts, setBroadcastTemplateOpts] = useState(null)
  const [homePage, setHomePage] = useState(null)
  const [contactInfo, setContactInfo] = useState(null)
  const [logoUrl, setLogoUrl] = useState(null)
  const [customOnboardingPage, setCustomOnboardingPage] = useState(null)
  const [taxRate, setTaxRate] = useState(0.0)
  const [taxType, setTaxType] = useState(findTaxTypeOpt("GST"))
  const [invokedBy, setInvokedBy] = useState(null)

  const [alert, setAlert] = useAlert()

  const [logoImageInfo, setLogoImageInfo] = useState(null)
  const logoImagePickerDialogRef = useRef(null)

  const params = useParams()

  const [touched, setTouched] = useState(null)

  const inpEmailAddressRef = useRef(null)

  // useEffect(() => {
  //   if (navigator.permissions) {
  //     navigator.permissions.query({name: "clipboard-write"}).then(result => {
  //       if (result.state == "granted" || result.state == "prompt") {
  //         setClipboardOpsAllowed(true)
  //       }
  //     })
  //   }
  // }, [])

  useEffect(() => {
    if (props) {
      if (props.tenant) {
        const t = props.tenant
        setTenant(t)
        // // log.debug(">>>Z: props.tenant=, user=", props.tenant, user)
        // if (!props.reinvite) {
        if (props.tenant.isSystem()) {
          // const o = [
          //   {
          //     value: "DEMO",
          //     label: intl.msg("reseller_type_demo")
          //   },
          //   {
          //     value: "HOUSE",
          //     label: intl.msg("reseller_type_house")
          //   },
          //   {
          //     value: "MASTER",
          //     label: intl.msg("reseller_type_network")
          //   },
          //   {
          //     value: "STANDALONE",
          //     label: intl.msg("reseller_type_standalone")
          //   }
          // ]
          // // setResellerTypeOpts(o.sort())
          const o = getInvitableResellerTypeOpts(props.tenant)
          // // log.debug(">>>Z: invitableResellers=", o)
          setResellerTypeOpts(o)
          setResellerType(o.find(o => o.value === "STANDALONE"))
          if (t.clientProps) {
            setCpm(t.clientProps.adSystem?.AMOBEE?.cpms?.IMAGE)
          }
          setInvokedBy(user)
        }
        else if (props.tenant.isReseller()) {
          const o = getInvitableResellerTypeOpts(props.tenant)
          setResellerTypeOpts(o)
          // // log.debug(">>>Z: invitableResellers=", o)
          setResellerType(o && o.length > 0 ? o[0] : null)
          setInvokedBy(props.tenant.owner)
        }
      }
    }
  }, [props])

  useEffect(() => {
    if (tenant) {
      setBusy(intl.msg("loading"))
      api.getRegion(tenant.regionId)
        .then(({data}) => {
          setRegion({
            value: data.regionId,
            label: data.regionName,
          })
          loadBroadcastTemplateOpts()
            .catch((error) => {
              setFatal(error)
            })
        })
        .catch((error) => {
          setFatal(error)
        })
        .finally(function () {
          setBusy(null)
        })
    }
  }, [tenant])

  function loadBroadcastTemplateOpts() {
    // log.debug("loadBroadcastTemplates")
    return api.getAllBroadcastTemplates(tenant.tenantId)
      .then(({data}) => {
        // log.debug("loadBroadcastTemplates: data=", data)
        let opts = []
        opts = data.map(bt => {return {
          value: bt.broadcastTemplateId,
          label: bt.broadcastTemplateName
        }})
        // log.debug("loadBroadcastTemplates: opt=", opts)
        setBroadcastTemplateOpts(opts)
        setBroadcastTemplates(opts)
        return opts
      })
      .catch(function (ex) {
        // log.debug("Load Region failed: error=", ex)
      })
  }

  function validate() {

    let opt = {focusEl: null, valid: true}

    clearAllErrors("frmMain")

    validateField("inp_fullName", fullName && fullName.trim().length > 0, "required", opt)

    validateField("inp_emailAddress", validateEmailAddress(emailAddress), "valid", opt)

    validateField("inp_tenantName", tenantName && (tenantName.trim().length > 0) && (tenantName !== emailAddress), "valid", opt)

    validateField("inp_contactName", contactName && contactName.trim().length > 0, "required", opt)
    validateField("inp_contactInfo", contactInfo && contactInfo.trim().length > 0, "required", opt)

    validateField("inp_homePage", validateUrl(homePage), "valid", opt)

    validateField("inp_logoUrl", logoUrl && logoUrl.trim().length > 0, "required", opt)

    validateField("inp_broadcastTemplates", broadcastTemplates && broadcastTemplates.length > 0, "required", opt)

    if (props.tenant.isSystem()) {

      validateField("inp_region", region, "required", opt)
      validateField("inp_tenantPlan", tenantPlan, "required", opt)

      if (["MASTER"].includes(resellerType?.value)) {
        validateField("inp_maxLevels", parseInt(maxLevels) > 1 && parseInt(maxLevels) <= 4, "range", opt)
      }

      if (commissionRates === null || commissionRates.length === 0) {
        validateField("inp_commission", false, "required", opt)
      }
      else {
        if (["STANDALONE", "SUB"].includes(resellerType?.value)) {
          const cs = parseFloat(commissionRates[0])
          validateField("inp_commission", !isNaN(cs) && cs > 0.00 && cs <= 90.00, "valid", opt)
        }
        else {
          if (maxLevels > commissionRates.length) {
            validateField("inp_commission_0", false, "valid", opt)
          }

          const cs = commissionRates.slice(0, maxLevels)

          if (cs.filter(c => isNaN(parseFloat(c))).length > 0) {
            validateField("inp_commission_0", false, "valid", opt)
          }
          else {
            const ttl = cs.map(c => parseFloat(c)).reduce((acc, curr) => acc + curr)
            // log.debug("validate: ttl=", ttl)
            if (isNaN(ttl) || ttl <= 0.00 || ttl > 90.00) {
              validateField("inp_commission_0", false, "valid", opt)
            }
          }
        }
      }

      if (numberIsNotBlank(taxRate)) {
        validateField("inp_taxType", taxType, "required", opt)
      }

    }

    if (customOnboardingPage && customOnboardingPage.trim().length > 0) {
      validateField("inp_customOnboardingPage", validateUrl(customOnboardingPage), "valid", opt)
    }

    if (opt.focusEl) {
      document.getElementById(opt.focusEl).focus()
    }

    return opt.valid

  }

  async function handleInviteClick() {

    // log.debug("handleInviteClick: 1")

    try {

      if (validate()) {

        setBusy(intl.msg("working"))

        let tid
        if (!tenantId) {
          const {data} = await api.createUuid()
          tid = data.uuid
        }
        else {
          tid = tenantId
        }

        // log.debug("handleInviteClick: tenantId=", tid)

        let finalLogoUrl = logoUrl

        if (finalLogoUrl && finalLogoUrl.startsWith("data:")) {
          finalLogoUrl = await uploadImage({
            api: api,
            env: env,
            imageData: finalLogoUrl,
            imagePath: `t/${tid}/logo`,
            setImageUrl: setLogoUrl,
          })
        }

        let payload = {
          fullName: fullName,
          emailAddress: emailAddress,
          tenantId: tid,
          tenantName: tenantName,
          tenantPlanId: tenantPlan.value,
          broadcastTemplateIds: broadcastTemplates.map(t => t.value),
          homePage: homePage,
          contactInfo: contactInfo,
          logoUrl: finalLogoUrl,
          customOnboardingPage: customOnboardingPage,
          taxRate: taxRate,
          taxType: taxType?.value,
          invokedById: invokedBy?.userId
        }

        if (props.tenant.isSystem()) {
          payload.parentId = null
          payload.regionId = region.value
          payload.industryId = env.defaultIndustryId // industry.value
          payload.maxDepth = resellerType.value === "MASTER" ? maxLevels - 1 : 0
          payload.commissionRates = (["DEMO", "HOUSE", "TEST"].includes(tenantPlan.value)) ? [] : commissionRates
          payload.affiliateCommissionRate = affiliateCommissionRate
          payload.affiliateAdjustmentRate = affiliateAdjustmentRate
        }
        else if (props.tenant.isReseller()) {
          // payload.parentId = parentReseller.value
        }
        else {
          setAlert({type: "error", text: intl.msg("error_failed")})
        }

        const {res} = await api.inviteReseller(payload)

        window.location = mkHref({suffix: `/resellers`, tenant: tenant, user: user})

      }
      else {
        setAlert({type: "error", text: intl.msg("error_validation")})
      }
    }
    catch (error) {
      log.error("Validation error: ", error)
      handleError(error)
    }
    finally {
      setBusy(null)
    }
  }

  function handleError(error) {
    if (error && error.code) {
      // log.debug("handleError", error.code)
      const code = error.code
      const details = error.details
      switch (code) {
        case "BANNED_INVITER":
          setAlert({type: "error", text: intl.msg("error_banned_user", details)})
          break
        case "UNKNOWN_INVITER":
        case "INVALID_INVITER":
          setAlert({type: "error", text: intl.msg("invite_error_invalid_inviter", details), field: "inp_emailAddresses", constraint: "valid"})
          break
        case "DUPLICATE_INVITEE_USER":
          setAlert({type: "error", text: intl.msg("invite_error_duplicate_user", details), field: "inp_emailAddresses", constraint: "unique"})
          break
        case "DUPLICATE_INVITEE_TENANT":
          setAlert({type: "error", text: intl.msg("invite_error_duplicate_tenant", details), field: "inp_tenantName", constraint: "unique"})
          break
        case "BANNED_EMAIL_ADDRESS":
          setAlert({type: "error", text: intl.msg("error_banned_email_address", details), field: "inp_emailAddresses", constraint: "valid"})
          break
        default:
          setAlert({type: "error", text: intl.msg("error_failed", details)})
          break
      }
    }
    else {
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  function loadRegions(input, options, additional) {
    // log.debug(">>>Z: loadRegions: ", input, options)
    return api.listRegions({view: "BASIC", extraParams: `${input ? `filter=regionName:${encodeURIComponent(input)}&` : ""}sort=regionName:ASC`, cursor: additional?.cursor, limit: 20})
      .then(({data, nextCursor}) => {
        let opt = data.map(c => {
          return {
            value: c.regionId,
            label: c.regionName,
            pop: c.pop
          };
        });
        let res = {
          options: opt,
        }
        if (nextCursor) {
          res = {
            ...res,
            hasMore: true,
            additional: {
              cursor: nextCursor
            }
          }
        }
        // log.debug("loadRegions: res=", res)
        return res
      });
  }

  function handleFullNameChange(e) {
    if (e) {
      let v = e.target?.value
      setFullName(v)
      setTouched(true)
    }
  }

  function handleEmailAddressChange(e) {
    if (e) {
      let v = e.target.value
      if (v) {
        v = v.toLowerCase()
      }
      setEmailAddress(v)
      setTouched(true)
    }
  }

  function handleRegionChange(v) {
    setRegion(v)
    setTouched(true)
  }

  function handleTenantPlanChange(v) {
    setTenantPlan(v)
    setTouched(true)
  }

  function handleResellerTypeChange(v) {
    setResellerType(v)
    setTouched(true)
  }

  // function handleResellerChange(v) {
  //   setParentReseller(v)
  //   setTouched(true)
  // }

  function handleMaxLevelsChange(v) {
    setMaxLevels(v)
    setTouched(true)
  }

  function handleCommissionsChange(i, v) {
    setCommissionRates(prev => {
      if (prev === null) {
        prev = []
      }
      if (i >= prev.length - 1) {
        const padLength = Math.max(0, i - prev.length + 1);
        prev = prev.concat(new Array(padLength).fill(0.00))
      }
      prev.splice(i, 1, v);
      // log.debug(">>>Z: handleCommissionsChange: prev=", [...prev]);
      return [...prev]
    })
  }

  const ttlCommissions = commissionRatesRef && commissionRatesRef.current ? commissionRatesRef.current.slice(0, maxLevelsRef && maxLevelsRef.current ? maxLevelsRef.current : 0).reduce((acc, cur) => cur ? acc + cur : acc) : 0.0

  function handleCpmChange(v) {
    setCpm(v)
    setTouched(true)
  }

  function handleTaxTypeChange(v) {
    setTaxType(v)
    setTouched(true)
  }

  function handleTaxRateChange(v) {
    setTaxRate(v)
    if (v <= 0.0) {
      setTaxType(null)
    }
    setTouched(true)
  }

  function handleTenantNameChange(e) {
    setTenantName(e.target.value)
    setTouched(true)
  }

  function handleContactNameChange(e) {
    setContactName(e.target.value)
    setTouched(true)
  }

  // function handleIndustryChange(v) {
  //   // log.debug("handleIndustryChange: v=", v)
  //   setIndustry(v)
  //   setTouched(true)
  // }

  function handleHomePageChange(e) {
    const value = e.target.value
    setHomePage(value)
    setTouched(true)
  }

  function handleHomePageBlur() {
    if (homePage && homePage.trim().length > 0) {
      try {
        if (homePage.startsWith("http://")) {
          setHomePage((prev) => `https://${prev.substring(7)}`)
        }
        else if (!homePage.startsWith("https://")) {
          setHomePage((prev) => `https://${prev}`)
        }
      }
      catch (e) {
      }
    }
  }

  function handleAffiliateCommissionRateChange(v) {
    setAffiliateCommissionRate(v)
    setTouched(true)
  }

  function handleAffiliateAdjustmentRateChange(v) {
    setAffiliateAdjustmentRate(v)
    setTouched(true)
  }

  function handleContactInfoChange(e) {
    setContactInfo(e.target.value)
    setTouched(true)
  }

  async function handleLogoChange(e) {

    if (e.target.files && e.target.files.length > 0) {
      let file = e.target.files[0]
      let result

      setBusy(intl.msg("processing"))

      try {
        result = await processImageFile({
          file: file,
          maxFileSize: 100_000,
          width: 100,
          height: 100,
        })
      }
      catch (ex) {
        setAlert({type: "error", text: "error_image_process_failed"})
      }
      finally {
        setBusy(null)
      }

      if (result.error) {
      // if (result.warning || result.error) {
        setLogoImageInfo(result)
        const el = document.getElementById("inp_dlg_logoImagePicker")
        el.click()
      }
      else {
        setLogoUrl(result.dataUrl)
        setTouched(true)
      }

      clearError("inp_logoUrl")
    }
  }

  function handleLogoClear() {
    setLogoUrl(null)
    setTouched(true)
  }

  function handleCustomOnboardingPageChange(e) {
    setCustomOnboardingPage(e.target.value)
    setTouched(true)
  }

  function Header(props) {
    return (
      <>
        <h1>{intl.msg("reseller_new_title")}</h1>
      </>
    )
  }

  function handleOpenDialog() {
    setAlert(null)
    if (inpEmailAddressRef.current) {
      // log.debug(">>>Z: openDialog: invoked", inpEmailAddressRef)
      inpEmailAddressRef.current.disabled = false
      inpEmailAddressRef.current.focus()
    }
  }

  function handleCloseDialog() {
    closeDialog("dlg_reseller_invite")
  }

  function isEditable() {
    return true
  }
  
  return (

    <>
      <ModalDialog
        dialogId="dlg_reseller_invite"
        size="md"
        keyboard="true"
        backdrop="static"
        onOpen={handleOpenDialog}
        onClose={handleCloseDialog}>

        <ModalDialog.Header
          title={intl.msg("reseller_invite_title")}
          description={intl.msg("reseller_invite_description")}
          alert={alert}
        />

        <ModalDialog.Body>

          <FormGroups>

            <FormGroup>
              <FormGroup.Label htmlFor="inp_fullName" text={intl.msg("account_invite_owner_name")} description={intl.msg("account_invite_owner_name_description")}/>
              <FormGroup.Controls>
                <input  id="inp_fullName" className="form-control" type="text" value={fullName} autoFocus onChange={handleFullNameChange}/>
                <InfoBlock>
                  <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                </InfoBlock>
              </FormGroup.Controls>
            </FormGroup>

            <FormGroup>
              <FormGroup.Label text={intl.msg("account_invite_email_address")} description={intl.msg("account_invite_email_address_description")} htmlFor="inp_emailAddress"/>
              <FormGroup.Control>
                <input ref={inpEmailAddressRef} key="inp_emailAddress" id="inp_emailAddress" className="form-control" type="text" value={emailAddress} onChange={handleEmailAddressChange} isDisabled={!isEditable()}/>
                <InfoBlock>
                  <InfoText validate="valid" disabled={!isEditable()}>{intl.msg("helptext_email_address_valid")}</InfoText>
                  <InfoText validate="unique" disabled={!isEditable()}>{intl.msg("helptext_email_address_unique")}</InfoText>
                  <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                </InfoBlock>
              </FormGroup.Control>
            </FormGroup>

          </FormGroups>

          <FormGroups>

            <FormGroup>
              <FormGroup.Label text={intl.msg("account_name")} description={intl.msg("account_invite_account_name_description")} htmlFor="inp_tenantName"/>
              <FormGroup.Control>
                <input className="form-control" type="text" key="inp_tenantName" id="inp_tenantName" value={tenantName} onChange={handleTenantNameChange} isDisabled={!isEditable()}/>
                <InfoBlock>
                  <InfoText validate="unique" disabled={!isEditable()}>{intl.msg("account_name_helptext_unique")}</InfoText>
                  <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                </InfoBlock>
              </FormGroup.Control>
            </FormGroup>

            {
              user?.isSystem() && props.tenant.isSystem() &&
                <>
                  <FormGroup>
                    <FormGroup.Label text={intl.msg("account_plan", {tenantType: "RESELLER"})} description={intl.msg("account_invite_account_plan_description", {tenantType: "RESELLER"})} htmlFor="inp_tenantPlan"/>
                    <FormGroup.Control>
                      <Select
                        id="inp_tenantPlan"
                        className="react-select"
                        classNamePrefix="react-select"
                        value={tenantPlan}
                        options={tenantPlanOpts}
                        hideSelectedOptions={true}
                        onChange={handleTenantPlanChange}
                      />
                      <InfoBlock>
                        <InfoText validate="required">{intl.msg("helptext_required")}</InfoText>
                      </InfoBlock>
                    </FormGroup.Control>
                  </FormGroup>

                  <FormGroup>
                    <FormGroup.Label text={intl.msg("region")} description={intl.msg("account_invite_region_description")} htmlFor="inp_region"/>
                    <FormGroup.Control>
                      <AsyncPaginate
                        className="react-select"
                        classNamePrefix="react-select"
                        cacheOptions
                        value={region}
                        defaultOptions={true}
                        loadOptions={loadRegions}
                        reduceOptions={reduceGroupedOptions}
                        placeholder=""
                        hideSelectedOptions={true}
                        isDisabled={!isEditable()}
                        onChange={handleRegionChange}
                      />
                      <InfoBlock>
                        <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                      </InfoBlock>
                    </FormGroup.Control>
                  </FormGroup>
                </>
            }

          </FormGroups>

        {
            !["DEMO", "HOUSE", "TEST"].includes(tenantPlan?.value) &&

              <FormGroups>

                <FormGroup>
                  <FormGroup.Label text={intl.msg("reseller_type")} description={intl.msg("reseller_type_description")} htmlFor="inp_resellerType"/>
                  <FormGroup.Control>
                    <Select
                      id="inp_resellerType"
                      className="react-select"
                      classNamePrefix="react-select"
                      value={resellerType}
                      options={resellerTypeOpts}
                      // hideSelectedOptions={true}
                      isSearchable={false}
                      onChange={handleResellerTypeChange}
                      isDisabled={(resellerTypeOpts?.length <= 1) || !isEditable()}
                    />
                    <InfoBlock>
                      <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                    </InfoBlock>
                  </FormGroup.Control>
                </FormGroup>

                {
                  resellerType?.value === "MASTER" ? (
                    <>

                      <FormGroup>
                        <FormGroup.Label text={intl.msg("reseller_max_levels")} description={intl.msg("reseller_max_levels_description")} htmlFor="inp_maxLevels"/>
                        <FormGroup.Control>
                          <div style={{width: "50px"}}>
                            <NumericInput id="inp_maxLevels" className="form-control" min={2} max={5} disabled={!isEditable()} value={maxLevels} onChange={handleMaxLevelsChange}/>
                          </div>
                          <InfoBlock>
                            <InfoText validate="range" disabled={!isEditable()}>{intl.msg("reseller_max_levels_helptext_valid", {minValue: tenant.commissionRates && tenant.commissionRates.length > 0 ? tenant.commissionRates.length : 2, maxValue: 5})}</InfoText>
                            <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                          </InfoBlock>
                        </FormGroup.Control>
                      </FormGroup>

                      {
                        maxLevels > 0 &&
                        <>
                          <FormGroup>
                            <FormGroup.Label text={intl.msg("reseller_commission_rates")} description={intl.msg("reseller_commission_rates_description")} htmlFor="inp_commission"/>
                            <FormGroup.Control>
                              <table border="0">
                                {
                                  rangeMap(0, maxLevels - 1, (i) => {
                                    return (
                                      <tr>
                                        <td>
                                          <label className="col-form-label pr-2" htmlFor={`inp_commission_${i}`}>
                                            <span>
                                              {
                                                i === 0 ? (
                                                  intl.msg("reseller_type_master")
                                                ) : maxLevels > 2 && i < maxLevels -1 ? (
                                                  intl.msg("reseller_type_super")
                                                ) : (
                                                  intl.msg("reseller_type_sub")
                                                )
                                              }:
                                            </span>
                                          </label>
                                        </td>
                                        <td>
                                          <div className="form-control-wrapper">
                                            <div style={{width: "70px"}}>
                                              <NumericInput id={`inp_commission_${i}`} className="form-control" min={1} max={99} decimals={2} disabled={!isEditable()} value={commissionRates && commissionRates.length > 0 ? commissionRates[i] : 0.00} onChange={(v) => handleCommissionsChange(i, v)}/>
                                            </div>
                                            <div className="form-control-suffix">%</div>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  })
                                }
                                <tr>
                                  <td>
                                    <label className="col-form-label pr-2" htmlFor="inp_commission">
                                      {intl.msg("total")}:
                                    </label>
                                  </td>
                                  <td>
                                    <div className="form-control-wrapper">
                                      <div style={{width: "70px"}}>
                                        <NumericInput id={`inp_commission_total`} className="form-control" min={1} max={99} decimals={2} disabled={true} value={ttlCommissions}/>
                                      </div>
                                      <div className="form-control-suffix">%</div>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                              <InfoBlock>
                                <InfoText validate="valid" disabled={!isEditable()}>{intl.msg("reseller_commission_rates_helptext_valid")}</InfoText>
                                <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                              </InfoBlock>
                            </FormGroup.Control>
                          </FormGroup>
                        </>
                      }

                    </>
                  ) : resellerType?.value === "STANDALONE" ? (
                    <>

                      <FormGroup>
                        <FormGroup.Label text={intl.msg("reseller_commission_rate")} description={intl.msg("reseller_commission_rate_description")} htmlFor="inp_commission"/>
                        <FormGroup.Control>
                          <div className="form-control-wrapper">
                            <div style={{width: "70px"}}>
                              <NumericInput id="inp_commission" className="form-control" min={1} max={99} decimals={2} disabled={!isEditable()} value={commissionRates && commissionRates.length > 0 ? commissionRates[0] : 0.00} onChange={(v) => handleCommissionsChange(0, v)}/>
                            </div>
                            <div className="form-control-suffix">%</div>
                          </div>
                          <InfoBlock>
                            <InfoText validate="valid" disabled={!isEditable()}>{intl.msg("reseller_commission_rate_helptext_valid")}</InfoText>
                            <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                          </InfoBlock>
                        </FormGroup.Control>
                      </FormGroup>

                      {/*<FormGroup>*/}
                      {/*  <FormGroup.Label text={intl.msg("account_tax")} description={intl.msg("account_tax_description")} htmlFor="inp_taxRate"/>*/}
                      {/*  <FormGroup.Control>*/}
                      {/*    <div className="d-flex flex-row gap-1">*/}
                      {/*      <div className="form-control-wrapper flex-row">*/}
                      {/*        <div style={{width: "70px"}}>*/}
                      {/*          <NumericInput id="inp_taxRate" className="form-control" min={0} max={99} decimals={2} disabled={!isEditable()} value={taxRate} onChange={handleTaxRateChange}/>*/}
                      {/*        </div>*/}
                      {/*        <div className="form-control-suffix">%</div>*/}
                      {/*      </div>*/}
                      {/*      <div style={{width: "150px"}}>*/}
                      {/*        {*/}
                      {/*          numberIsNotBlank(taxRate) &&*/}
                      {/*            <Select*/}
                      {/*              id="inp_taxType"*/}
                      {/*              className="react-select"*/}
                      {/*              classNamePrefix="react-select"*/}
                      {/*              value={taxType}*/}
                      {/*              options={taxTypeOpts}*/}
                      {/*              placeholder={"Select tax type..."}*/}
                      {/*              onChange={handleTaxTypeChange}*/}
                      {/*              isDisabled={user?.isReseller() || !isEditable()}*/}
                      {/*            />*/}
                      {/*        }*/}
                      {/*      </div>*/}
                      {/*    </div>*/}
                      {/*    <InfoBlock>*/}
                      {/*      <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>*/}
                      {/*    </InfoBlock>*/}
                      {/*  </FormGroup.Control>*/}
                      {/*</FormGroup>*/}
                    </>

                  ) : (
                    <></>
                  )
                }

                {
                  ["MASTER", "STANDALONE"].includes(resellerType?.value) ? (
                    <>
                      <FormGroup>
                        <FormGroup.Label text={intl.msg("reseller_affiliate_commission")} description={intl.msg("reseller_affiliate_commission_description")} htmlFor="inp_affiliateCommissionRate"/>
                        <FormGroup.Control>
                          <div className="d-flex flex-row gap-1">
                            <div className="form-control-wrapper flex-row">
                              <div style={{width: "70px"}}>
                                <NumericInput id="inp_affiliateCommissionRate" className="form-control" min={0} max={99} decimals={2} disabled={!isEditable()} value={affiliateCommissionRate} onChange={handleAffiliateCommissionRateChange}/>
                              </div>
                              <div className="form-control-suffix">%</div>
                            </div>
                          </div>
                          <InfoBlock>
                            <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                          </InfoBlock>
                        </FormGroup.Control>
                      </FormGroup>

                      {
                        numberIsNotBlank(affiliateCommissionRate) &&
                          <FormGroup>
                            <FormGroup.Label text={intl.msg("reseller_affiliate_adjustment")} description={intl.msg("reseller_affiliate_adjustment_description")} htmlFor="inp_affiliateAdjustmentRate"/>
                            <FormGroup.Control>
                              <div className="d-flex flex-row gap-1">
                                <div className="form-control-wrapper flex-row">
                                  <div style={{width: "70px"}}>
                                    <NumericInput id="inp_affiliateAdjustmentRate" className="form-control" min={0} max={99} decimals={2} disabled={!isEditable()} value={affiliateAdjustmentRate} onChange={handleAffiliateAdjustmentRateChange}/>
                                  </div>
                                  <div className="form-control-suffix">%</div>
                                </div>
                              </div>
                              <InfoBlock>
                                <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                              </InfoBlock>
                            </FormGroup.Control>
                          </FormGroup>

                      }

                      <FormGroup>
                        <FormGroup.Label text={intl.msg("account_tax")} description={intl.msg("account_tax_description")} htmlFor="inp_taxRate"/>
                        <FormGroup.Control>
                          <div className="d-flex flex-row gap-1">
                            <div className="form-control-wrapper flex-row">
                              <div style={{width: "70px"}}>
                                <NumericInput id="inp_taxRate" className="form-control" min={0} max={99} decimals={2} disabled={!isEditable()} value={taxRate} onChange={handleTaxRateChange}/>
                              </div>
                              <div className="form-control-suffix">%</div>
                            </div>
                            <div style={{width: "150px"}}>
                              {
                                numberIsNotBlank(taxRate) &&
                                  <Select
                                    id="inp_taxType"
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    value={taxType}
                                    options={taxTypeOpts}
                                    placeholder={"Select tax type..."}
                                    onChange={handleTaxTypeChange}
                                    isDisabled={user?.isReseller() || !isEditable()}
                                  />
                              }
                            </div>
                          </div>
                          <InfoBlock>
                            <InfoText validate="required" disabled={!isEditable()}>{intl.msg("helptext_required")}</InfoText>
                          </InfoBlock>
                        </FormGroup.Control>
                      </FormGroup>
                    </>
                  ) : (
                    <></>
                  )
                }

              </FormGroups>
          }

          <FormGroups>

            <FormGroup>
              <FormGroup.Label text={intl.msg("account_contact_name")} description={intl.msg("account_contact_name_description")} htmlFor="inp_contactName"/>
              <FormGroup.Control>
                <input className="form-control" type="text" key="inp_contactName" id="inp_contactName" value={contactName} onChange={handleContactNameChange} isDisabled={!isEditable()}/>
                <InfoBlock>
                  <InfoText validate="required">{intl.msg("helptext_required")}</InfoText>
                </InfoBlock>
              </FormGroup.Control>
            </FormGroup>

            <FormGroup>
              <FormGroup.Label htmlFor="inp_contactInfo" description={intl.msg("account_contact_info_description")}>
                {intl.msg("account_contact_info")}
              </FormGroup.Label>
              <FormGroup.Control>
                <textarea id="inp_contactInfo" className="form-control" rows="2" autoComplete="off" value={contactInfo} disabled={!isEditable()} onChange={handleContactInfoChange} style={{whiteSpace: "pre-line"}}/>
                <InfoBlock>
                  <InfoText validate="required">{intl.msg("helptext_required")}</InfoText>
                </InfoBlock>
              </FormGroup.Control>
            </FormGroup>

            <FormGroup>
              <FormGroup.Label htmlFor="inp_homePage" description={intl.msg("account_home_page_description")}>
                {intl.msg("account_home_page")}
              </FormGroup.Label>
              <FormGroup.Control>
                <div className="input-group">
                  <input id="inp_homePage" type="text" className="form-control" value={homePage} onChange={handleHomePageChange} onBlur={handleHomePageBlur}/>
                  {
                    validateUrl(homePage) &&
                      <div className="input-group-append">
                        <button className="btn btn-secondary" style={{borderTop: "1px solid #555", borderRight: "1px solid #555", borderBottom: "1px solid #555", width: "41px"}} type="button" title="View page in new browser tab" onClick={(e) => window.open(homePage)}><Icon name="external-link"/></button>
                      </div>
                  }
                </div>
                <InfoBlock>
                  <InfoText validate="valid">{intl.msg("helptext_web_address_valid")}</InfoText>
                  <InfoText validate="required">{intl.msg("helptext_required")}</InfoText>
                </InfoBlock>
              </FormGroup.Control>
            </FormGroup>

            <FormGroup>
              <FormGroup.Label htmlFor="inp_logoUrl" description={intl.msg("account_logo_description")}>
                {intl.msg("account_logo")}
              </FormGroup.Label>
              <FormGroup.Control>
                <ImageDropBox
                  id="inp_logoUrl"
                  image={logoUrl}
                  imageClassName={"account-logo"}
                  width={100}
                  height={100}
                  onChange={handleLogoChange}
                  onClear={handleLogoClear}
                  disabled={!isEditable()}/>
                <InfoBlock>
                  <InfoText>{intl.msg("account_invite_logo_helptext_2")}</InfoText>
                  <InfoText validate="valid_size">{intl.msg("account_invite_logo_helptext_valid_size")}</InfoText>
                  <InfoText validate="required">{intl.msg("helptext_required")}</InfoText>
                </InfoBlock>
              </FormGroup.Control>
            </FormGroup>

          </FormGroups>

        </ModalDialog.Body>

        <ModalDialog.Footer>
          <ModalDialog.Footer.Controls>
            {
              touched &&
                <ActionButton name="apply" text={intl.msg("add_new")} flavor="primary" onClick={handleInviteClick}/>
            }
            <ActionButton name="cancel" onClick={handleCloseDialog}/>
          </ModalDialog.Footer.Controls>
        </ModalDialog.Footer>

    </ModalDialog>

    <ImageDialog
      ref={logoImagePickerDialogRef}
      id="dlg_logoImagePicker"
      title="Logo Image"
      imageInfo={logoImageInfo}
      setTargetImageData={setLogoUrl}
      setTouched={setTouched}/>
    </>
  )
}
